export default __webpack_public_path__ + "static/media/ic_review_black.924474b0.svg";